export default __webpack_public_path__ + "static/media/G0001.3230a281.png";